import React, { useState } from "react";
import { FaStore, FaTruck, FaUsers, FaShoppingCart } from "react-icons/fa";

const concessionImages = [
  "img/concession/concession1.png",
  "img/concession/concession2.png",
  "img/concession/concession3.png",
  "img/concession/concession4.png",
  "img/concession/concession5.png",
  "img/concession/concession6.png",
  "img/concession/concession7.png",
  "img/concession/concession8.png",
  "img/concession/concession9.png",
  "img/concession/concession10.png",
  "img/concession/concession11.png",
  "img/concession/concession12.png",
  "img/concession/concession13.png",
  "img/concession/concession14.png",
];

const trailerImages = [
  "img/trailer/trailer1.jpg",
  "img/trailer/trailer2.jpg",
  "img/trailer/trailer3.png",
  "img/trailer/trailer4.png",
];

const items = [
  {
    id: 1,
    icon: <FaStore />,
    title: "Merchandise concession infrastructure",
    short: "Custom built infrastructure to deliver a seamless merchandise experience.",
    type: "gallery-list",
    gallery: concessionImages,
    content: [
      "Merchandise retail pop-up operations",
      "Temporary concession stands",
      "Mobile retail trailers",
      "Point of Sale",
      "Mobile Eftpos",
      "Retail presentation and display",
    ],
  },
  {
    id: 2,
    icon: <FaTruck />,
    title: "Mobile Retail Trailer Unit",
    short: "Fully equipped mobile retail solutions that go wherever your event is.",
    type: "trailer",
    gallery: trailerImages,
    intro:
      "EMS offers a unique retail distribution opportunity of purpose-built mobile merchandise concession trailers. These trailers can be fully operated as self-contained, stand-alone retail operations at any event and location.",
    features: [
      "Galvanised R.H.S base frame and chassis",
      "Walls, ceiling and roof constructed from 50mm poly-panel",
      "Tandem axles with hydraulic override & front axle brakes",
      "Rear stabilizing jacks",
      "Double bay awning side lift windows with gas lift struts",
      "120V single phase electrical system with fluorescent lighting",
      "Tempered safety glass sales display counter",
      "Multipurpose rear slat wall adjustable display fittings",
    ],
    brandingText:
      "Trailers can be branded with bespoke designed signage ranging from single colour to all-over full colour vinyl.",
    branding: ["Header board", "Base boards", "Side panels", "Full wrap vinyl"],
  },
  {
    id: 3,
    icon: <FaUsers />,
    title: "Staff and supervision",
    short: "Experienced, professional staff to keep operations running smoothly.",
    type: "list",
    content: [
      "Event merchandise management",
      "Client representation and relationship management",
      "Vending staff",
      "Programme sellers",
      "Stock controllers",
      "Cash handling and accounts",
      "Runners",
      "Stand security",
    ],
  },
  {
    id: 4,
    icon: <FaShoppingCart />,
    title: "E-commerce online store",
    short: "Online stores that extend your event reach and grow your brand.",
    type: "text-list",
    text:
      "EMS can design, build, and operate direct sale to customers from online stores of your retail licensed and branded merchandise product. EMS provides fulfilment services, warehousing, inventory management, pick/packing, despatch of all orders, and customer service.",
    content: [
      "Fully responsive online store",
      "Creative front-end design and build",
      "Warehouse integration",
      "Payment gateway integration",
      "Full sales reconciliation",
    ],
  },
];

const ServicesSection = () => {
  const [openItem, setOpenItem] = useState(null);
  const [popupGallery, setPopupGallery] = useState([]);
  const [popupIndex, setPopupIndex] = useState(null);

  const selectedItem = items.find((item) => item.id === openItem);

  const handleLearnMore = (id) => {
    setOpenItem(openItem === id ? null : id);

    setTimeout(() => {
      const content = document.getElementById("services-details");
      if (content) {
        content.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  const openPopup = (gallery, index) => {
    setPopupGallery(gallery);
    setPopupIndex(index);
  };

  const closePopup = () => {
    setPopupGallery([]);
    setPopupIndex(null);
  };

  const goNext = (e) => {
    e.stopPropagation();
    setPopupIndex((prev) => (prev + 1) % popupGallery.length);
  };

  const goPrev = (e) => {
    e.stopPropagation();
    setPopupIndex((prev) =>
      prev === 0 ? popupGallery.length - 1 : prev - 1
    );
  };

  return (
    <>
      <section className="servicesSection">
        {/* <p className="servicesLabel">OUR SERVICES</p> */}

        <h2>Everything you need for a successful event</h2>

        <p className="servicesIntro">
          From concept to completion, we provide end-to-end merchandise and
          retail solutions tailored to your event.
        </p>

        <div className="servicesGrid">
          {items.map((item) => (
            <div
              key={item.id}
              className={`serviceCard ${openItem === item.id ? "active" : ""}`}
            >
              <div className="serviceIcon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.short}</p>

              <button
                type="button"
                className="learnMoreBtn"
                onClick={() => handleLearnMore(item.id)}
              >
                {openItem === item.id ? "CLOSE" : "LEARN MORE"} →
              </button>
            </div>
          ))}
        </div>

        {selectedItem && (
          <div id="services-details" className="serviceDetails">
            <h3>{selectedItem.title}</h3>

            {selectedItem.type === "list" && (
              <ul className="contentList">
                {selectedItem.content.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ul>
            )}

            {selectedItem.type === "gallery-list" && (
              <>
                <ul className="contentList">
                  {selectedItem.content.map((text, index) => (
                    <li key={index}>{text}</li>
                  ))}
                </ul>

                <div className="galleryGrid">
                  {selectedItem.gallery.map((image, index) => (
                    <button
                      type="button"
                      key={index}
                      className="galleryItem"
                      onClick={() => openPopup(selectedItem.gallery, index)}
                    >
                      <img src={image} alt={`Gallery ${index + 1}`} />
                    </button>
                  ))}
                </div>
              </>
            )}

            {selectedItem.type === "text-list" && (
              <>
                <p className="detailText">{selectedItem.text}</p>
                <ul className="contentList">
                  {selectedItem.content.map((text, index) => (
                    <li key={index}>{text}</li>
                  ))}
                </ul>
              </>
            )}

            {selectedItem.type === "trailer" && (
              <>
                <p className="detailText">{selectedItem.intro}</p>

                <h4>Key features</h4>
                <ul className="contentList">
                  {selectedItem.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>

                <div className="brandingBox">
                  <h4>Branding options</h4>
                  <p>{selectedItem.brandingText}</p>

                  <ul className="contentList">
                    {selectedItem.branding.map((option, index) => (
                      <li key={index}>{option}</li>
                    ))}
                  </ul>
                </div>

                <div className="galleryGrid">
                  {selectedItem.gallery.map((image, index) => (
                    <button
                      type="button"
                      key={index}
                      className="galleryItem"
                      onClick={() => openPopup(selectedItem.gallery, index)}
                    >
                      <img src={image} alt={`Trailer ${index + 1}`} />
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        <div className="coverageLine">
          <span></span>
          <p>✓ Nationwide coverage across New Zealand</p>
          <span></span>
        </div>
      </section>

      {popupIndex !== null && (
        <div className="popupOverlay" onClick={closePopup}>
          <button className="popupClose" onClick={closePopup}>
            ×
          </button>

          <button className="popupArrow popupLeft" onClick={goPrev}>
            ‹
          </button>

          <img
            className="popupImage"
            src={popupGallery[popupIndex]}
            alt={`Gallery ${popupIndex + 1}`}
            onClick={(e) => e.stopPropagation()}
          />

          <button className="popupArrow popupRight" onClick={goNext}>
            ›
          </button>

          <div className="popupCounter">
            {popupIndex + 1} / {popupGallery.length}
          </div>
        </div>
      )}

      <style>{`
        .servicesSection {
          width: 100%;
          padding: 10px 20px;
          background: #ffffff;
          text-align: center;
          font-family: Arial, sans-serif;
        }

        .servicesLabel {
          color: #008cff;
          font-size: 15px;
          font-weight: 800;
          letter-spacing: 2px;
          margin-bottom: 12px;
        }

        .servicesSection h2 {
          color: #07194a;
          font-size: 35px;
          line-height: 1.1;
          font-weight: 900;
          margin: 0;
        }

        .servicesIntro {
          max-width: 680px;
          margin: 24px auto 60px;
          color: #56627a;
          font-size: 20px;
          line-height: 1.5;
        }

        .servicesGrid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 28px;
        }

        .serviceCard {
          min-height: 360px;
          padding: 48px 34px 38px;
          border: 1px solid #dfe5ef;
          border-radius: 12px;
          background: #ffffff;
          box-shadow: 0 10px 24px rgba(7, 25, 74, 0.05);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          transition: all 0.3s ease;
        }

        .serviceCard:hover,
        .serviceCard.active {
          transform: translateY(-6px);
          box-shadow: 0 18px 36px rgba(7, 25, 74, 0.12);
          border-color: #008cff;
        }

        .serviceIcon {
          font-size: 72px;
          color: #007cff;
          margin-bottom: 28px;
        }

        .serviceCard h3 {
          color: #07194a;
          font-size: 24px;
          line-height: 1.15;
          font-weight: 900;
          margin: 0 0 22px;
        }

        .serviceCard p {
          color: #56627a;
          font-size: 17px;
          line-height: 1.45;
          margin: 0 0 30px;
        }

        .learnMoreBtn {
          background: transparent;
          border: none;
          color: #008cff;
          font-size: 15px;
          font-weight: 900;
          letter-spacing: 1px;
          cursor: pointer;
        }

        .serviceDetails {
          max-width: 1200px;
          margin: 55px auto 0;
          text-align: left;
          background: #f8fbff;
          border: 1px solid #dfe5ef;
          border-radius: 18px;
          padding: 45px;
          box-shadow: 0 15px 35px rgba(7, 25, 74, 0.08);
        }

        .serviceDetails h3 {
          color: #07194a;
          font-size: 32px;
          margin: 0 0 25px;
        }

        .serviceDetails h4 {
          color: #07194a;
          font-size: 22px;
          margin: 30px 0 15px;
        }

        .detailText {
          color: #56627a;
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 25px;
        }

        .contentList {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 14px 30px;
          padding-left: 20px;
          color: #56627a;
          font-size: 17px;
          line-height: 1.5;
        }

        .contentList li::marker {
          color: #008cff;
        }

        .brandingBox {
          background: #ffffff;
          border-radius: 14px;
          border: 1px solid #dfe5ef;
          padding: 28px;
          margin: 30px 0;
        }

        .galleryGrid {
          margin-top: 35px;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 18px;
        }

        .galleryItem {
          border: none;
          padding: 0;
          background: transparent;
          cursor: pointer;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(7, 25, 74, 0.12);
        }

        .galleryItem img {
          width: 100%;
          height: 180px;
          object-fit: cover;
          display: block;
          transition: transform 0.3s ease;
        }

        .galleryItem:hover img {
          transform: scale(1.06);
        }

        .coverageLine {
          max-width: 1300px;
          margin: 60px auto 0;
          display: flex;
          align-items: center;
          gap: 24px;
          color: #56627a;
          font-size: 20px;
        }

        .coverageLine span {
          flex: 1;
          height: 1px;
          background: #dfe5ef;
        }

        .coverageLine p {
          margin: 0;
          white-space: nowrap;
        }

        .popupOverlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.88);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .popupImage {
          max-width: 88vw;
          max-height: 85vh;
          object-fit: contain;
        }

        .popupClose {
          position: absolute;
          top: 22px;
          right: 30px;
          background: transparent;
          border: none;
          color: white;
          font-size: 46px;
          cursor: pointer;
        }

        .popupArrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.15);
          border: none;
          color: white;
          font-size: 60px;
          width: 60px;
          height: 80px;
          cursor: pointer;
        }

        .popupLeft {
          left: 30px;
        }

        .popupRight {
          right: 30px;
        }

        .popupCounter {
          position: absolute;
          bottom: 24px;
          color: white;
          font-size: 16px;
        }

        @media (max-width: 1100px) {
          .servicesGrid {
            grid-template-columns: repeat(2, 1fr);
          }

          .galleryGrid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 600px) {
          .servicesSection {
            padding: 60px 16px;
          }

          .servicesSection h2 {
            font-size: 34px;
          }

          .servicesIntro {
            font-size: 17px;
            margin-bottom: 40px;
          }

          .servicesGrid {
            grid-template-columns: 1fr;
          }

          .serviceDetails {
            padding: 28px 20px;
          }

          .contentList {
            grid-template-columns: 1fr;
          }

          .galleryGrid {
            grid-template-columns: repeat(2, 1fr);
          }

          .galleryItem img {
            height: 130px;
          }

          .coverageLine {
            font-size: 16px;
            gap: 12px;
          }

          .coverageLine p {
            white-space: normal;
          }

          .popupArrow {
            font-size: 44px;
            width: 45px;
          }
        }
      `}</style>
    </>
  );
};

export default ServicesSection;